exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add_config-dialog .el-form .el-input,.add_config-dialog .el-input-number,.add_config-dialog .el-select{width:100%!important}", ""]);

// exports
